<template>
  <v-app>
    <app-navigation v-if="isAuthenticated" />
    <v-main class="active-metals-main">
      <metal-prices-banner v-if="isAuthenticated" />
      <router-view :key="$route.fullPath"></router-view>
    </v-main>
  </v-app>
</template>
<script>
import AppNavigation from "@/components/AppNavigation";
import MetalPricesBanner from "@/components/MetalPricesBanner.vue";
import { mapActions as preciousMetalsMapActions } from "@/store/modules/preciousMetals";
import { mapGetters as userMapGetters, mapActions as userMapActions } from "@/store/modules/user";

export default {
  name: "App",
  created() {
    setInterval(() => {
      if (this.isAuthenticated) {
        this.metalsFetch();
      }
    }, 30000);
  },
  methods: {
    ...preciousMetalsMapActions({
      metalsFetch: "fetch",
    }),
    ...userMapActions(["logout"]),
    toggleDrawer() {
      this.drawer = !this.drawer;
    }
  },
  watch: {
    isAuthenticated(val) {
      // watch if authenticated state changes and release metal price fetch immediately
      // let continuous fetch call run independently
      if (val) {
        this.metalsFetch();
      }
    },
  },
  components: {
    AppNavigation,
    MetalPricesBanner,
  },
  computed: {
    ...userMapGetters(["isAuthenticated", "isAdmin"]),
  },
};
</script>
<style lang="scss">
@import "resources/sass/app.scss";
.active-metals-main {
  background-color: var(--v-background-base);
}
</style>
